import React from "react";
import { NavLink } from "react-router-dom";
import { styled } from "@mui/system";

const StyledNavLink = styled(NavLink)({
  textDecoration: "none",
  color: "rgb(100, 100, 100)",
  padding: "6px 14px",
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 400,
  fontSize: "0.875rem",
  transition: "color 0.2s ease",
  "&:hover": {
    color: "#616161",
  },
  "&.active": {
    fontWeight: 600,
    color: "#1d1d1f",
  },
});

const NavButton = ({ link, tag }) => {
  return (
    <StyledNavLink to={link} activeclassname="active">
      {tag}
    </StyledNavLink>
  );
};

export default NavButton;
